export default {
  operator: 'Operador',
  user: 'Usuario',
  value: 'Valor',
  date: 'Fecha',
  operators: 'Operadores',
  status: 'Estado',
  users: 'Usuarios',
  export: 'Exportar como XLSX',
  infoLabel: 'Información del Componente',
  filterLabel: 'Aplicar filtro',
  trashLabel: 'Limpiar filtro',
  closeLabel: 'Cerrar información',
  statusLabel: 'Estado',
  openOperatorLabel: 'Abrir conversaciones del operador',
  viewChat: 'Ver conversaciones',
  faq: [
    {
      title: '¿Qué es?',
      description: 'Tabla de estado de operadores en Smart Care para seguimiento de actividad.',
    },
    {
      title: '¿Cómo alterar el Operador?',
      description: 'Para cambiar el filtro, debe hacer clic en el campo “Operadores“, seleccionar los Operadores deseados y hacer clic en el ícono de "filtro" en la parte superior derecha de la tabla, luego se mostrarán solo las anotaciones de los operadores seleccionados.',
    },
    {
      title: '¿Cómo filtrar por estado del operador?',
      description: 'Para filtrar por estado, debe hacer clic en el campo "Estado del operador", seleccionar si desea filtrar solo los operadores "ONLINE" o "OFFLINE",',
    },
    {
      title: '¿Cómo redefinir el filtro?',
      description: 'Para redefinir el filtro, debe hacer clic en el ícono de "papelera", debajo del ícono de "filtro", así todos los filtros de la tabla se restablecerán al valor predeterminado',
    },
  ],
  username: 'Nombre del usuario',
  lastStatus: 'Última actualización',
  offlineText: 'Ausente',
  onlineText: 'Activo',
};
